import { Typography } from '@mui/material';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import React from 'react';
import { ColWidth } from './common';

export const getActionsColumn = (
	actions: (params: GridRowParams) => any[]
) => ({
	field: 'actions',
	type: 'actions',
	key: 'actions',
	width: ColWidth.s + 10,
	getActions: actions,
	renderHeader: () => (
		<Typography variant="overline" color="text.secondary" display="none">
			{intl.tr('fields.common.column.actions')}
		</Typography>
	)
});

export const getActionCell = (onClick: () => void, label: string) => (
	<GridActionsCellItem
		label={intl.tr(label)}
		onClick={onClick}
		showInMenu
		sx={{
			fontSize: 'body2.fontSize'
		}}
	/>
);
